export default __webpack_public_path__ + "static/media/bg.e265e5db.png";